// extracted by mini-css-extract-plugin
export default {"danger":"PrettyButton_danger__6wRWL","pretty":"PrettyButton_pretty__h+kMM"};